module.exports = __webpack_public_path__ + "static/media/star_admin.36ac2f02.svg";